var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-settings",attrs:{"id":"modal-settings"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal($event)}}},[_c('div',{staticClass:"modal-settings__inner"},[_c('Settings')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }